export default __webpack_public_path__ + "static/media/back-button.09fa98c7.png";